import { TourStep } from './tour.typings'

/** The first match for `selector`, when it is laid out on the page. */
export const findTourTarget = (selector: string): Element | null => {
    const node = document.querySelector(selector)
    if (!node) return null
    const bounds = node.getBoundingClientRect()
    return bounds.width > 0 || bounds.height > 0 ? node : null
}

/**
 * Keep the steps that apply to the page right now. A page can be in several states (a strategy
 * picked or not, one OI screen or another), so a step list describes every state and the tour
 * that runs is the subset whose targets are on screen. A step's `requires` selector gates it on
 * a page state; lazy elements are revealed by the step itself and are not checked; extra
 * spotlights (elements without text) are optional.
 */
export const resolveTourSteps = (steps: TourStep[]): TourStep[] =>
    steps.filter((step) => {
        if (step.requires && !findTourTarget(step.requires)) return false
        const required = step.elements.filter((element) => !element.lazy && element.text)
        if (required.length && !required.every((element) => findTourTarget(element.selector))) return false
        return step.elements.some((element) => element.lazy || findTourTarget(element.selector))
    })
